export default __webpack_public_path__ + "static/media/Me-documentation.8eae0983.md";